// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1aoLN","content":"LayoutSettings_content__1_eKc"};